import { render, staticRenderFns } from "./OrdersAnalytics.vue?vue&type=template&id=2a6a3418&scoped=true"
import script from "./OrdersAnalytics.vue?vue&type=script&lang=js"
export * from "./OrdersAnalytics.vue?vue&type=script&lang=js"
import style0 from "./OrdersAnalytics.vue?vue&type=style&index=0&id=2a6a3418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a3418",
  null
  
)

export default component.exports